import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, FormControlLabel, Checkbox, FormHelperText } from "@material-ui/core";


const useStyles = makeStyles(theme => ({
    formControl: {
        marginTop: '0.4rem',
    },
    root: {

    },
}));

const CheckBoxComp = ({ error, label, size, className, helperText, formProps, ...rest }) => {
    const classes = useStyles();
    return (
        <FormControl className={classes.formControl} error={error} {...formProps}>
            <FormControlLabel
                label={label}
                control={
                    <Checkbox className={clsx(classes.root, className)} size={size} {...rest} />
                }
                className={classes.formControl}
            />
            {error && <FormHelperText variant="outlined">{helperText}</FormHelperText>}
        </FormControl>
    );
};

CheckBoxComp.propTypes = {
    error: PropTypes.string,
    label: PropTypes.string.isRequired,
    size: PropTypes.string,
    className: PropTypes.string,
    helperText: PropTypes.string,
    formProps: PropTypes.object,
};

CheckBoxComp.defaultProps = {
    error: PropTypes.string,
    size: "medium",
    className: '',
    helperText: PropTypes.string,
    formProps: {},
};

export default CheckBoxComp;

